/**
 * Jambuveda — product tutorial video, click-to-load, with a real close button.
 * The YouTube iframe is only created when the customer clicks "Watch how to
 * use" — not on every page load. Closing removes the iframe entirely (not
 * just hides it), so the video genuinely stops playing rather than
 * continuing to play audio in the background off-screen.
 */
(function () {
  document.querySelectorAll('[data-jv-video-toggle]').forEach((btn) => {
    const wrapper = btn.parentElement;
    const frame = wrapper.querySelector('[data-jv-video-frame]');
    const embed = wrapper.querySelector('[data-jv-video-embed]');
    const videoId = embed.dataset.videoId;

    function openVideo() {
      if (!embed.querySelector('iframe')) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        iframe.title = 'Product tutorial video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        embed.appendChild(iframe);
      }
      frame.hidden = false;
      btn.style.display = 'none';
    }

    function closeVideo() {
      // Remove the iframe entirely (not just hide it) so the video actually
      // stops playing — a hidden-but-present iframe would keep playing audio.
      const iframe = embed.querySelector('iframe');
      if (iframe) iframe.remove();
      frame.hidden = true;
      btn.style.display = '';
    }

    // Build the close button once, inside the video frame
    if (!wrapper.querySelector('[data-jv-video-close]')) {
      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'jv-pdp__video-close';
      closeBtn.setAttribute('data-jv-video-close', '');
      closeBtn.setAttribute('aria-label', 'Close video');
      closeBtn.textContent = '✕';
      closeBtn.addEventListener('click', closeVideo);
      frame.appendChild(closeBtn);
    }

    btn.addEventListener('click', openVideo);
  });
})();
